import { render, staticRenderFns } from "./paytickets.vue?vue&type=template&id=21459846&scoped=true&"
import script from "./paytickets.vue?vue&type=script&lang=js&"
export * from "./paytickets.vue?vue&type=script&lang=js&"
import style0 from "./paytickets.vue?vue&type=style&index=0&id=21459846&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21459846",
  null
  
)

export default component.exports